/**
 * Formats an array value for display, truncating if necessary
 * @param {Array|*} value - The value to format (array or other)
 * @param {Object} options - Formatting options
 * @param {number} options.maxItems - Maximum number of items to show before truncating (default: 3)
 * @param {string} options.separator - Separator between items (default: ', ')
 * @returns {string} Formatted display string
 */
export function formatArrayForDisplay(value, { maxItems = 3, separator = ', ' } = {}) {
  if (Array.isArray(value)) {
    if (value.length <= maxItems) {
      return value.join(separator);
    }
    return `${value.slice(0, maxItems).join(separator)}... (${value.length} total)`;
  }
  return String(value);
}
